module.exports = __webpack_public_path__ + "img/operationCapacity10.2faa0187.png";